import React from "react";
import { useCompleteProfile } from "@/context/CompleteProfileContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

const CompletionStep = () => {
  const { nextStep, saving } = useCompleteProfile();

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100dvh-200px)] text-center px-4">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="space-y-6"
      >
        {/* Success Icon */}
        <div className="relative">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
            className="w-24 h-24 rounded-full bg-gradient-to-br from-[#C4406B] to-[#9F3764] flex items-center justify-center mx-auto"
          >
            <CheckCircle2 className="w-12 h-12 text-white" />
          </motion.div>
          
          {/* Sparkles animation */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="absolute -top-2 -right-2"
          >
            <Sparkles className="w-8 h-8 text-luxury-pinkBright" />
          </motion.div>
        </div>

        {/* Title */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-3xl font-bold text-white"
        >
          Perfil Completo! 🎉
        </motion.h2>

        {/* Description */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="text-white/70 text-lg max-w-md"
        >
          Agora você está pronto para fazer conexões incríveis na Interlaced
        </motion.p>

        {/* Benefits */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="bg-white/5 border border-white/10 rounded-2xl p-6 max-w-sm mx-auto space-y-4"
        >
          <h3 className="text-white font-semibold">O que você desbloqueou:</h3>
          <ul className="space-y-3 text-left">
            <li className="flex items-center gap-3 text-white/80">
              <span className="w-6 h-6 rounded-full bg-luxury-pinkBright/20 flex items-center justify-center flex-shrink-0">
                ✓
              </span>
              Acesso completo ao chat
            </li>
            <li className="flex items-center gap-3 text-white/80">
              <span className="w-6 h-6 rounded-full bg-luxury-pinkBright/20 flex items-center justify-center flex-shrink-0">
                ✓
              </span>
              Maior visibilidade no feed
            </li>
            <li className="flex items-center gap-3 text-white/80">
              <span className="w-6 h-6 rounded-full bg-luxury-pinkBright/20 flex items-center justify-center flex-shrink-0">
                ✓
              </span>
              Matches mais compatíveis
            </li>
          </ul>
        </motion.div>

        {/* CTA Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="pt-4"
        >
          <Button
            onClick={nextStep}
            disabled={saving}
            className="px-8 py-6 text-lg font-semibold bg-gradient-to-r from-[#C4406B] to-[#9F3764] hover:from-[#D4507B] hover:to-[#AF4774] text-white border-0"
          >
            Começar a Explorar
            <span className="ml-2">→</span>
          </Button>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default CompletionStep;
